import { Injectable } from '@angular/core';

/** Visibility flags for the app shell's header chrome. */
@Injectable({
  providedIn: 'root'
})
export class ShellService {
  showHeaderNav: boolean;
  showNotificationsIcon: boolean;
}
